import {connect} from "react-redux"
import State from "../../ducks/state"
import urls from "../../config/urls"

export const mapStateToProps = (state: State) => {
    const {cleanSiteUrl} = state.request
    const {
        text: {
            checkout: {text},
        },
        template,
    } = state
    return {
        enable: state.shoppingBag.itemCount > 0,
        text,
        url: `${cleanSiteUrl}${urls.checkout.url}`,
        templating: template,
    }
}

export default connect(mapStateToProps)
